<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'main.nav.links.upload.fullLabel' | translate}}
                <app-tooltip [text]="'main.nav.links.upload.summary' | translate"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="provider === 'bbc2020'">
        <mat-tab-group (selectedTabChange)="tabSelected($event)" color="accent" animationDuration="0ms">
            <mat-tab [label]="'files.form.provider.title.bbcTab.fullLabel' | translate" *ngIf="doesShowProviders">
                <app-upload-provider></app-upload-provider>
            </mat-tab>
            <mat-tab [label]="'files.form.simulation.bbcTab.fullLabel' | translate">
                <app-upload-simulation></app-upload-simulation>
            </mat-tab>
            <mat-tab [label]="'files.form.uploadBizzDev.shortLabel' | translate"
                *ngIf="roleUser === 'bizzdev' || roleUser === 'backoffice'">
                <app-upload-bizzdev></app-upload-bizzdev>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
    <mat-card-content *ngIf="provider === 'bdcsAndSic' || provider === 'sicbxl'">
        <mat-tab-group (selectedTabChange)="tabSelected($event)" color="accent" animationDuration="0ms">
            <mat-tab [label]="'files.form.provider.title.default.fullLabel' | translate" *ngIf="doesShowProviders">
                <app-upload-provider></app-upload-provider>
            </mat-tab>
            <mat-tab [label]="'files.form.simulation.title.fullLabel' | translate">
                <app-upload-simulation></app-upload-simulation>
            </mat-tab>
            <mat-tab [label]="'files.form.uploadBizzDev.shortLabel' | translate"
                *ngIf="roleUser === 'bizzdev' || roleUser === 'backoffice'">
                <app-upload-bizzdev></app-upload-bizzdev>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>
